import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import moment from 'moment';
import Helmet from 'react-helmet';
import RaisedButton from 'material-ui/RaisedButton';
import { DraftPostEditBar, DraftPostTopBar } from 'components/DraftPostItem';
import { ChatArea, ChatAreaInput, Modal, PageHeader, PostListContent, Spinner } from 'components';
import * as styles from './DraftPostItem.scss';

function DraftPostItem(props) {
  var approveDraftPost = props.approveDraftPost,
      deletePost = props.deletePost,
      draftFeedbackThreads = props.draftFeedbackThreads,
      feedbackThread = props.feedbackThread,
      getFeedbackThread = props.getFeedbackThread,
      handleEdit = props.handleEdit,
      handlePostFeedback = props.handlePostFeedback,
      organization = props.organization,
      parsedLinks = props.parsedLinks,
      parseLink = props.parseLink,
      post = props.post,
      requestDraftApproval = props.requestDraftApproval,
      setSnackbarMessage = props.setSnackbarMessage,
      showEditBar = props.showEditBar,
      showTopBar = props.showTopBar,
      user = props.user;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showFeedbackModal = _useState2[0],
      setShowFeedbackModal = _useState2[1];

  if (post.S3Files && post.S3Files.length) {
    var compareByPlacement = function compareByPlacement(a, b) {
      if (a.PostS3File.placement > b.PostS3File.placement) {
        return 1;
      } else if (a.PostS3File.placement < b.PostS3File.placement) {
        return -1;
      } else {
        return 0;
      }
    };

    post.S3Files.sort(compareByPlacement);
  }

  var hasImages = post.S3Files && post.S3Files.length ? [post.S3Files[0].fullyQualifiedUrl] : null;
  var postType = 'textPost';

  if (post.linkUrl) {
    postType = 'linkPost';
  } else if (hasImages) {
    postType = 'imagePost';
  } else if (post.videoUrl) {
    postType = 'videoPost';
  }

  if (postType === 'linkPost') {
    if (parsedLinks[post.linkUrl]) {
      post.linkData = parsedLinks[post.linkUrl];
    } else {
      parseLink(post.linkUrl);
    }
  }

  var hasFeedback = draftFeedbackThreads && draftFeedbackThreads.length ? draftFeedbackThreads.find(function (thread) {
    return parseInt(thread.subjectId) === parseInt(post.DraftPost.id);
  }) : false;
  var suggestedPublishAtRender = post.DraftPost && post.DraftPost.suggestedPublishAt ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13
    }
  }, "This post will be scheduled for ", moment(post.DraftPost.suggestedPublishAt).format('h:mm A'), " on", ' ', moment(post.DraftPost.suggestedPublishAt).format('dddd M/D/YYYY'), '.') : null;
  var belowMessageContent = postType === 'linkPost' ? /*#__PURE__*/React.createElement("a", {
    href: post.linkUrl,
    style: {
      color: '#1f5180',
      textDecoration: 'none',
      fontSize: 13
    },
    target: "_blank"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-link",
    style: {
      marginRight: 6
    }
  }), "Link Post") : postType === 'videoPost' ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13
    }
  }, "Video Post") : null;
  var message = post.message ? post.message : postType === 'linkPost' && post.linkData ? post.linkData.parsing ? 'Loading...' : post.linkData.description : 'No message';
  var imageUrl = post.S3Files.length ? post.S3Files[0].fullyQualifiedUrl : '';
  var image = imageUrl;
  var images = post.S3Files.length ? post.S3Files.map(function (f) {
    return f.fullyQualifiedUrl;
  }) : '';

  if (postType === 'linkPost' && !imageUrl) {
    if (post.linkData && !post.linkData.parsing && post.linkData.imageUrl) {
      image = post.linkData.imageUrl;
    }
  }

  var feedbackMessages = feedbackThread && feedbackThread.FeedbackMessages && feedbackThread.FeedbackMessages.length ? feedbackThread.FeedbackMessages : [];
  var videoUrl = post.videoUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.draftPostWrap
  }, post && post.DraftPost && !post.DraftPost.approvedAt && showEditBar && /*#__PURE__*/React.createElement(DraftPostEditBar, {
    handleEdit: handleEdit,
    setSnackbarMessage: setSnackbarMessage,
    requestDraftApproval: requestDraftApproval,
    organization: organization,
    post: post,
    deletePost: deletePost,
    showFeedbackModal: function showFeedbackModal() {
      return setShowFeedbackModal(true);
    },
    hasFeedback: hasFeedback,
    getFeedbackThread: getFeedbackThread
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrap,
    style: {
      flex: '1'
    }
  }, post && post.DraftPost && showTopBar && /*#__PURE__*/React.createElement(DraftPostTopBar, {
    setSnackbarMessage: setSnackbarMessage,
    approveDraftPost: approveDraftPost,
    handleEdit: handleEdit,
    organization: organization,
    post: post
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrap
  }, /*#__PURE__*/React.createElement(PostListContent, {
    style: {
      padding: 12
    },
    videoUrl: videoUrl,
    image: image,
    images: images,
    message: message,
    belowMessageContent: belowMessageContent,
    suggestedPublishAtRender: suggestedPublishAtRender
  }))), /*#__PURE__*/React.createElement(Modal, {
    actions: [/*#__PURE__*/React.createElement(RaisedButton, {
      label: "Close",
      onClick: function onClick() {
        setShowFeedbackModal(false);
      },
      style: {
        marginRight: 24
      }
    }), /*#__PURE__*/React.createElement(RaisedButton, {
      secondary: true,
      label: "Edit Post",
      onClick: function onClick() {
        handleEdit(post);
      }
    })],
    title: "Draft Post Feedback",
    open: showFeedbackModal,
    onRequestClose: function onRequestClose() {
      setShowFeedbackModal(false);
    }
  }, /*#__PURE__*/React.createElement(PostListContent, {
    style: {
      padding: 12,
      paddingBottom: 0
    },
    videoUrl: videoUrl,
    image: image,
    images: images,
    message: message,
    belowMessageContent: belowMessageContent,
    suggestedPublishAtRender: suggestedPublishAtRender
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(ChatArea, {
    messages: feedbackMessages,
    user: user
  }), /*#__PURE__*/React.createElement(ChatAreaInput, {
    handlePostFeedback: handlePostFeedback
  })));
}

DraftPostItem.defaultProps = {
  showEditBar: true,
  showTopBar: true
};
export default DraftPostItem;